<template>
    <table class="el-year-table" @mousedown.prevent>
        <tbody>
            <tr v-for="(row, rIdx) in grid" :key="rIdx">
                <td
                    v-for="y in row"
                    :key="y"
                    :class="getCellClass(y)"
                    @click="pickYear(y)"
                >
                    <a class="cell">{{ y }}</a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  date?: Date;
  modelValue?: Date | null;
}>(), {
    date: () => new Date(),
    modelValue: null,
});

const emit = defineEmits<{
  (e: 'update:modelValue', v: Date | null): void;
  (e: 'pick', v: Date): void;
}>();

const panel = computed(() => props.date ?? new Date());

const startYear = computed(() => {
    const y = panel.value.getFullYear();
    return Math.floor(y / 10) * 10 - 1;
});

const grid = computed(() => {
    const start = startYear.value;
    const years: number[] = Array.from({ length: 12 }, (_, i) => start + i);
    return [years.slice(1, 5), years.slice(5, 9), years.slice(9, 11)];
});

function getCellClass(y: number) {
    const todayYear = new Date().getFullYear();
    const selectedYear = props.date ? new Date(props.date).getFullYear() : null;

    return {
        'current': selectedYear === y,
        'today': todayYear === y,
    };
}

function pickYear(y: number) {
    const d = new Date(y, panel.value.getMonth(), 1);
    emit('update:modelValue', d);
    emit('pick', d);
}
</script>
